import React from "react"
import { auditShape } from "utils/propTypeShapes"

const ReportExportAuditItemDetails = ({ audit }) => {
  const { reportName, reportType } = audit
  return (
    <div>
      Exported {reportType}: {reportName}.
    </div>
  )
}

ReportExportAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ReportExportAuditItemDetails
